import { CSSObject } from '@chakra-ui/react';
import { CustomButtonProps } from '@/components/Button/Button';

export const TextCheckbox: CSSObject = {
  color: 'white',
};

export const buttonCloseAccountProps: CustomButtonProps = {
  h: '10',
  variant: 'secondary',
};
